import request from '@/utils/request';

export function getChartDetail(values) {
  return request('/profile/group/groupTagChartByTagId', {
    method: 'POST',
    data: values,
  });
}
export function getGroupInfo(values) {
  return request('/profile/groupChartInfo', {
    method: 'POST',
    data: values,
  });
}
